export interface TopAppsReportResult {
  appId: string;
  totalDuration: number;
  name: string;
  logoUrl?: string;
  displayColor?: string;
  cumulativeAverageDurationDifference?: number;
}

export interface TopAppsReportV2Result {
  appId: string;
  totalDuration: number;
  cumulativeAverageDurationDifference?: number;
}
